import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class GroupCodeService
{
    private readonly $apiService = inject(ApiService);


    Lookup(pCriteria: LookupCriteria): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IGroupCodeService/LookupGroupCode", pCriteria);
    }

    getAllGroupCodes(): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IGroupCodeService/GetAllGroupCodes");
    }
}
